export const TYPES = {
  CommandHistory: Symbol.for('core/CommandHistory'),
  HotKeysService: Symbol.for('core/HotKeysService'),
  CoreModule: Symbol.for('core/CoreModule'),
  CommandProcessor: Symbol.for('core/CommandProcessor'),
  ObservabilityLoggerService: Symbol.for('ObservabilityLoggerService')
};
